import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { SortSelect, sortData } from '../components/SortSelect';
import { FilterPanel } from '../components/FilterPanel';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Checkbox } from '../components/ui/checkbox';
import { ExportDialog } from '../components/ExportDialog';
import { useExport } from '../hooks/useExport';
import { exportTableToPDF } from '../utils/html2pdfExport';
import { TesisTuruSecici } from '../components/TesisTuruSecici';
import { tesisTuruText, tesisTuruList, tesisTuruMatches, tesisTuruOptionsFrom } from '../utils/tesisTuru';
import { OdenekDetailDialog } from '../components/modules/bakim-onarim/OdenekDetailDialog';
import { exportOdenekDetayPDF } from '../utils/bakimDetayPdf';
import * as XLSX from 'xlsx';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BAKIM_EXPORT_COLUMNS = [
  {id: 'yil', label: 'Yıl'}, {id: 'isin_adi', label: 'İşin Adı'},
  {id: 'tesis_turu', label: 'Tesis Türü'}, {id: 'tesis_adi', label: 'Tesis Adı'},
  {id: 'ilce', label: 'İlçe'}, {id: 'talep_yeri', label: 'Talep Yeri'},
  {id: 'butce_tertibi', label: 'Bütçe Tertibi'}, {id: 'alim_turu', label: 'Alım Türü'},
  {id: 'odenek_tutari', label: 'Ödenek Tutarı'}, {id: 'ilgilenen_memur', label: 'İlgilenen Memur'},
  {id: 'odenek_talep_tarihi', label: 'Ödenek Talep Tarihi'}, {id: 'talep_yazi_no', label: 'Talep Yazı No'},
  {id: 'odenek_durumu', label: 'Ödenek Durumu'}, {id: 'ek_taahhut_odenek_durumu', label: 'Ek Taahhüt Ödenek Durumu'},
  {id: 'ek_protokol_odenek_durumu', label: 'Ek Protokol Ödenek Durumu'}, {id: 'aciklama', label: 'Açıklama'}
];

const ISTANBUL_ILCELERI = [
  'İSTANBUL',
  'ADALAR', 'ARNAVUTKÖY', 'ATAŞEHİR', 'AVCILAR', 'BAĞCILAR', 'BAHÇELİEVLER', 
  'BAKIRKÖY', 'BAŞAKŞEHİR', 'BAYRAMPAŞA', 'BEŞİKTAŞ', 'BEYKOZ', 'BEYLİKDÜZÜ',
  'BEYOĞLU', 'BÜYÜKÇEKMECE', 'ÇATALCA', 'ÇEKMEKÖY', 'ESENLER', 'ESENYURT',
  'EYÜPSULTAN', 'FATİH', 'GAZİOSMANPAŞA', 'GÜNGÖREN', 'KADIKÖY', 'KAĞITHANE',
  'KARTAL', 'KÜÇÜKÇEKMECE', 'MALTEPE', 'PENDİK', 'SANCAKTEPE', 'SARIYER',
  'SİLİVRİ', 'SULTANBEYLİ', 'SULTANGAZİ', 'ŞİLE', 'ŞİŞLİ', 'TUZLA',
  'ÜMRANİYE', 'ÜSKÜDAR', 'ZEYTİNBURNU'
];

const BUTCE_TERTIBI_KODLARI = [
  '33.256.795.16807-9900.34-02-03.05',
  '33.256.795.16807-9900.34-02-03.07',
  '33.256.795.16807-9900.34-02-03.08',
  '33.256.795.16807-9900.34-02-06.07',
  '33.256.794.16825-9900.34-02-03.05',
  '33.256.794.16825-9900.34-02-03.07',
  '33.256.794.16825-9900.34-02-03.08',
  '33.256.794.16825-9900.34-02-06.07',
  '34.89.239.16808-9900.34-02-03.05',
  '34.89.239.16808-9900.34-02-03.07',
  '34.89.239.16808-9900.34-02-03.08',
  '34.89.239.16810-9900.34-02-06.07',
  '62.87.234.16812-9900.34-02-03.05',
  '62.87.234.16812-9900.34-02-03.07',
  '62.87.234.16812-9900.34-02-03.08',
  '62.87.234.16814-9900.34-02-06.07',
  '62.87.234.16812.9900.34.02.06.07.90.01',
  '98.900.9006.16826-9900.34-02-03.05',
  '98.900.9006.16826-9900.34-02-03.07',
  '98.900.9006.16826-9900.34-02-03.08',
  '98.900.9006.16825-9900.34-02-06.07',
  '98.900.9006.16826.9900.34.02.06.07/90.01'
];

const BakimOnarimPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [sortKey, setSortKey] = useState('newest');
  const [submitting, setSubmitting] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
  const [selectedPdfDialogOpen, setSelectedPdfDialogOpen] = useState(false);
  const [excelDialogOpen, setExcelDialogOpen] = useState(false);
  const { selectedColumns, setSelectedColumns, pdfPageSize, setPdfPageSize, toggleColumn, selectAll, clearAll } = useExport();
  const [users, setUsers] = useState([]);
  const [detailRecord, setDetailRecord] = useState(null);
  const [dtLinkedIds, setDtLinkedIds] = useState(new Set());
  const [formData, setFormData] = useState({
    yil: new Date().getFullYear().toString(),
    isin_adi: '',
    tesis_turu: [],
    ilce: '',
    alim_turu: '',  // YENİ
    talep_yeri: 'STRATEJİ',
    butce_tertibi: '',
    odenek_tutari: '',
    ilgilenen_memur: '',
    odenek_talep_tarihi: '',
    talep_yazi_no: '',
    odenek_durumu: '',
    aciklama: ''
  });
  const [filters, setFilters] = useState({
    yil: [],
    tesis_turu: [],
    talep_yeri: [],
    ilgilenen_memur: [],
    odenek_durumu: [],
    isin_adi: '',
    ilce: [],
    alim_turu: [],
    butce_tertibi: [],
    aciklama: ''
  });

  useEffect(() => {
    if (!user?.is_admin && !user?.has_bakim_onarim_access) {
      navigate('/dashboard');
      return;
    }
    fetchRecords();
    fetchUsers();
    fetchDtLinkedIds();
  }, []);

  const fetchDtLinkedIds = async () => {
    try {
      const response = await axios.get(`${API}/bakim-onarim/dogrudan-temin/used-odenek-ids`, { withCredentials: true });
      setDtLinkedIds(new Set(response.data?.ids || []));
    } catch (error) {
      console.error('DT linked ids fetch error:', error);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API}/users-simple`, {
        withCredentials: true
      });
      setUsers(response.data);
    } catch (error) {
      console.error('Users fetch error:', error);
    }
  };

  const fetchRecords = async () => {
    try {
      const response = await axios.get(`${API}/bakim-onarim/odenek`, {
        withCredentials: true
      });
      setRecords(response.data);
    } catch (error) {
      console.error('Records fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  const displayMoney = (value) => {
    if (!value) return '';
    const cleaned = value.replace(/[^0-9,]/g, '');
    if (!cleaned) return '';
    const parts = cleaned.split(',');
    const integerPart = parts[0];
    const decimalPart = parts[1];
    const formatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const result = decimalPart !== undefined ? `${formatted},${decimalPart.substring(0, 2)}` : formatted;
    return result ? result + ' TL' : '';
  };


  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      if (editMode) {
        await axios.put(`${API}/bakim-onarim/odenek/${selectedRecord.id}`, formData, { withCredentials: true });
      } else {
        await axios.post(`${API}/bakim-onarim/odenek`, formData, { withCredentials: true });
      }
      setDialogOpen(false);
      resetForm();
      fetchRecords();
    } catch (error) {
      console.error('Submit error:', error);
      alert('İşlem sırasında hata oluştu');
    } finally {
      setSubmitting(false);
    }
  };

  const handleEdit = (record) => {
    setSelectedRecord(record);
    setFormData({
      yil: record.yil || new Date().getFullYear().toString(),
      isin_adi: record.isin_adi || '',
      tesis_turu: tesisTuruList(record.tesis_turu),
      tesis_adi: record.tesis_adi || '',
      ilce: record.ilce || '',
      alim_turu: record.alim_turu || '',
      talep_yeri: record.talep_yeri || 'STRATEJİ',
      butce_tertibi: record.butce_tertibi || '',
      odenek_tutari: record.odenek_tutari || '',
      ilgilenen_memur: record.ilgilenen_memur || '',
      odenek_talep_tarihi: record.odenek_talep_tarihi || '',
      talep_yazi_no: record.talep_yazi_no || '',
      odenek_durumu: record.odenek_durumu || '',
      aciklama: record.aciklama || ''
    });
    setEditMode(true);
    setDialogOpen(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu kaydı silmek istediğinizden emin misiniz?')) return;
    try {
      await axios.delete(`${API}/bakim-onarim/odenek/${id}`, { withCredentials: true });
      fetchRecords();
    } catch (error) {
      console.error('Delete error:', error);
      alert('Silme işlemi başarısız');
    }
  };

  const resetForm = () => {
    setFormData({
      yil: new Date().getFullYear().toString(),
      isin_adi: '',
      tesis_turu: [],
      ilce: '',
      alim_turu: '',
      talep_yeri: 'STRATEJİ',
      butce_tertibi: '',
      odenek_tutari: '',
      ilgilenen_memur: '',
      odenek_talep_tarihi: '',
      talep_yazi_no: '',
      odenek_durumu: '',
      aciklama: ''
    });
    setEditMode(false);
    setSelectedRecord(null);
  };

  // Filtreleme fonksiyonu
  const getFilteredRecords = () => {
    return records.filter(record => {
      if (filters.yil.length > 0 && !filters.yil.includes(record.yil?.toString())) return false;
      if (!tesisTuruMatches(record.tesis_turu, filters.tesis_turu)) return false;
      if (filters.talep_yeri.length > 0 && !filters.talep_yeri.includes(record.talep_yeri)) return false;
      if (filters.ilgilenen_memur.length > 0 && !filters.ilgilenen_memur.includes(record.ilgilenen_memur)) return false;
      if (filters.odenek_durumu.length > 0 && !filters.odenek_durumu.includes(record.odenek_durumu)) return false;
      if (filters.isin_adi && !record.isin_adi?.toLowerCase().includes(filters.isin_adi.toLowerCase())) return false;
      if (filters.ilce.length > 0 && !filters.ilce.includes(record.ilce)) return false;
      if (filters.alim_turu.length > 0 && !filters.alim_turu.includes(record.alim_turu)) return false;
      if (filters.butce_tertibi.length > 0 && !filters.butce_tertibi.includes(record.butce_tertibi)) return false;
      if (filters.aciklama && !record.aciklama?.toLowerCase().includes(filters.aciklama.toLowerCase())) return false;
      return true;
    });
  };

  const filteredRecords = getFilteredRecords();


  // Satır seçme fonksiyonları
  const toggleRowSelection = (recordId) => {
    if (selectedRows.includes(recordId)) {
      setSelectedRows(selectedRows.filter(id => id !== recordId));
    } else {
      setSelectedRows([...selectedRows, recordId]);
    }
  };

  const toggleAllRows = () => {
    if (selectedRows.length === filteredRecords.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(filteredRecords.map(r => r.id));
    }
  };

  // Finansal özet hesaplama
  const getSelectedRecordsSummary = () => {
    const selectedRecordsData = filteredRecords.filter(r => selectedRows.includes(r.id));
    
    const totalOdenek = selectedRecordsData.reduce((sum, record) => {
      const tutar = parseFloat((record.odenek_tutari || '0').replace(/[^0-9,]/g, '').replace(',', '.'));
      return sum + (isNaN(tutar) ? 0 : tutar);
    }, 0);

    return {
      count: selectedRecordsData.length,
      totalOdenek: totalOdenek.toFixed(2).replace('.', ','),
      records: selectedRecordsData
    };
  };

  // Seçili kayıtları PDF olarak export et
  const exportSelectedToPDF = () => {
    const summary = getSelectedRecordsSummary();
    if (summary.count === 0) {
      alert('Lütfen en az bir kayıt seçin');
      return;
    }
    setSelectedPdfDialogOpen(true);
  };

  const exportSelectedToPDFWithColumns = async () => {
    const summary = getSelectedRecordsSummary();
    if (selectedColumns.length === 0) {
      alert('Lütfen en az bir sütun seçin');
      return;
    }

    const columnMapping = {
      'yil': 'Yıl', 'isin_adi': 'İşin Adı', 'tesis_turu': 'Tesis Türü',
      'tesis_adi': 'Tesis Adı', 'ilce': 'İlçe', 'talep_yeri': 'Talep Yeri',
      'butce_tertibi': 'Bütçe Tertibi', 'alim_turu': 'Alım Türü',
      'odenek_tutari': 'Ödenek Tutarı', 'ilgilenen_memur': 'İlgilenen Memur',
      'odenek_talep_tarihi': 'Ödenek Talep Tarihi', 'talep_yazi_no': 'Talep Yazı No',
      'odenek_durumu': 'Ödenek Durumu', 'aciklama': 'Açıklama',
      'ek_taahhut_odenek_durumu': 'Ek Taahhüt Ödenek Durumu',
      'ek_protokol_odenek_durumu': 'Ek Protokol Ödenek Durumu'
    };

    const headers = ['S.NO', ...selectedColumns.map(col => columnMapping[col] || col)];
    const tableData = summary.records.map((record, idx) => [
      idx + 1,
      ...selectedColumns.map(col => {
        if (col === 'odenek_tutari') return displayMoney(record[col]);
        if (col === 'tesis_turu') return tesisTuruText(record[col]);
        return record[col] || '';
      })
    ]);

    const totalRow = ['TOPLAM'];
    selectedColumns.forEach(col => {
      if (col === 'odenek_tutari') {
        const total = summary.records.reduce((sum, record) => {
          const tutar = parseFloat((record.odenek_tutari || '0').replace(/[^0-9,]/g, '').replace(',', '.'));
          return sum + (isNaN(tutar) ? 0 : tutar);
        }, 0);
        totalRow.push(displayMoney(total.toFixed(2).replace('.', ',')));
      } else {
        totalRow.push('');
      }
    });

    await exportTableToPDF(headers, [...tableData, totalRow], 'Bakım-Onarım Seçili Kayıtlar', 'bakim-onarim-secili-kayitlar.pdf', {
      subtitle: `Seçili: ${summary.count} | Toplam: ${displayMoney(summary.totalOdenek)}`,
      hasTotalRow: true,
      pageSize: pdfPageSize
    });
    setSelectedPdfDialogOpen(false);
  };

  const exportToExcel = () => {
    if (selectedColumns.length === 0) {
      alert('Lütfen en az bir sütun seçin');
      return;
    }

    const dataToExport = filteredRecords.map(record => {
      const row = {};
      selectedColumns.forEach(col => {
        const columnNames = {
          'yil': 'YIL', 'isin_adi': 'İŞİN ADI', 'tesis_turu': 'TESİS TÜRÜ',
          'tesis_adi': 'TESİS ADI', 'ilce': 'İLÇE', 'talep_yeri': 'TALEP YERİ',
          'butce_tertibi': 'BÜTÇE TERTİBİ', 'alim_turu': 'ALIM TÜRÜ',
          'odenek_tutari': 'ÖDENEK TUTARI (KDV DAHİL)', 'ilgilenen_memur': 'İLGİLENEN MEMUR',
          'odenek_talep_tarihi': 'ÖDENEK TALEP TARİHİ', 'talep_yazi_no': 'TALEP YAZI NO',
          'odenek_durumu': 'ÖDENEK DURUMU', 'aciklama': 'AÇIKLAMA',
          'ek_taahhut_odenek_durumu': 'EK TAAHHÜT ÖDENEK DURUMU',
          'ek_protokol_odenek_durumu': 'EK PROTOKOL ÖDENEK DURUMU'
        };
        row[columnNames[col] || col] = col === 'tesis_turu' ? tesisTuruText(record[col]) : (record[col] || '');
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Bakım-Onarım Ödenek');
    XLSX.writeFile(wb, 'bakim-onarim-odenek.xlsx');
    setExcelDialogOpen(false);
  };

  const exportToPDF = async () => {
    if (selectedColumns.length === 0) {
      alert('Lütfen en az bir sütun seçin');
      return;
    }

    const columnMapping = {
      'yil': 'Yıl', 'isin_adi': 'İşin Adı', 'tesis_turu': 'Tesis Türü',
      'tesis_adi': 'Tesis Adı', 'ilce': 'İlçe', 'talep_yeri': 'Talep Yeri',
      'butce_tertibi': 'Bütçe Tertibi', 'alim_turu': 'Alım Türü',
      'odenek_tutari': 'Ödenek Tutarı', 'ilgilenen_memur': 'İlgilenen Memur',
      'odenek_talep_tarihi': 'Ödenek Talep Tarihi', 'talep_yazi_no': 'Talep Yazı No',
      'odenek_durumu': 'Ödenek Durumu', 'aciklama': 'Açıklama',
      'ek_taahhut_odenek_durumu': 'Ek Taahhüt Ödenek Durumu',
      'ek_protokol_odenek_durumu': 'Ek Protokol Ödenek Durumu'
    };

    const headers = selectedColumns.map(col => columnMapping[col] || col);
    const tableData = filteredRecords.map(record => 
      selectedColumns.map(col => {
        if (col === 'odenek_tutari') return displayMoney(record[col]);
        if (col === 'tesis_turu') return tesisTuruText(record[col]);
        return record[col] || '';
      })
    );

    const totalRow = selectedColumns.map((col, colIdx) => {
      if (colIdx === 0) return 'TOPLAM';
      if (col === 'odenek_tutari') {
        const total = filteredRecords.reduce((sum, record) => {
          const tutar = parseFloat((record.odenek_tutari || '0').replace(/[^0-9,]/g, '').replace(',', '.'));
          return sum + (isNaN(tutar) ? 0 : tutar);
        }, 0);
        return displayMoney(total.toFixed(2).replace('.', ','));
      }
      return '';
    });

    await exportTableToPDF(headers, [...tableData, totalRow], 'Bakım-Onarım Ödenek Talepleri', 'bakim-onarim-odenek.pdf', {
      hasTotalRow: true,
      pageSize: pdfPageSize
    });
    setPdfDialogOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="text-white">Yükleniyor...</div>
      </div>
    );
  }


  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950">
      {/* Header */}
      <header className="bg-gray-900/50 border-b border-gray-800 backdrop-blur-sm sticky top-0 z-10">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img src="/logo.png" alt="Kurumsal İş Yönetimi, Takip ve Koordinasyon Platformu Logo" className="w-12 h-12 object-contain cursor-pointer" onClick={() => navigate('/dashboard')} />
              <div>
                <h1 className="text-xl font-bold text-white">Kurumsal İş Yönetimi, Takip ve Koordinasyon Platformu</h1>
                <p className="text-xs text-gray-400">Bakım-Onarım</p>
              </div>
            </div>
            <div className="flex items-center space-x-1">
              <button
                onClick={() => navigate('/')}
                className="px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-800/50 rounded-lg transition-colors"
                data-testid="anasayfa-nav-button"
              >
                Anasayfa
              </button>
              <span className="text-gray-600">|</span>
              <button
                onClick={() => navigate('/dashboard')}
                className="px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-800/50 rounded-lg transition-colors"
              >
                Dashboard
              </button>
              <span className="text-gray-600">|</span>
              <button
                onClick={() => navigate('/bakim-onarim/odenek')}
                className="px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-800/50 rounded-lg transition-colors border-b-2 border-blue-500"
              >
                🔧 Bakım-Onarım - Ödenek
              </button>
              <div className="ml-4 border-l border-gray-700 pl-4 flex items-center space-x-4">
                <div 
                  className="flex items-center space-x-3 bg-gray-800/50 rounded-lg px-4 py-2 cursor-pointer hover:bg-gray-800/70 transition-colors"
                  onClick={() => navigate('/profile')}
                >
                  <img src={user?.picture} alt={user?.name} className="w-8 h-8 rounded-full" />
                  <div className="text-left">
                    <p className="text-sm font-medium text-white">{user?.name}</p>
                    <p className="text-xs text-gray-400">
                      {user?.is_admin ? 'Admin' : 'Kullanıcı'}
                    </p>
                  </div>
                </div>
                <Button onClick={handleLogout} variant="ghost" className="text-red-400 hover:text-red-300">
                  Çıkış
                </Button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-white mb-2">🔧 Bakım-Onarım Ödenek Talepleri</h2>
            <p className="text-gray-400">Ödenek taleplerini görüntüleyin ve yönetin</p>
          </div>
          <div className="flex gap-3">
            <Button onClick={() => setExcelDialogOpen(true)} className="bg-green-600 hover:bg-green-700 text-white">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Excel İndir
            </Button>
            <Button onClick={() => setPdfDialogOpen(true)} className="bg-red-600 hover:bg-red-700 text-white">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
              PDF İndir
            </Button>
            {!user?.is_viewer && (
              <Button 
                onClick={() => {
                  resetForm();
                  setDialogOpen(true);
                }} 
                className="bg-blue-600 hover:bg-blue-700 text-white"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Yeni Talep Ekle
              </Button>
            )}
          </div>
        </div>

        {/* Filtreleme */}
        <FilterPanel
          filters={filters}
          setFilters={setFilters}
          totalCount={records.length}
          filteredCount={filteredRecords.length}
          resetFilters={() => setFilters({ yil: [], tesis_turu: [], talep_yeri: [], ilgilenen_memur: [], odenek_durumu: [], isin_adi: '', ilce: [], alim_turu: [], butce_tertibi: [], aciklama: '' })}
          filterConfig={[
            { key: 'isin_adi', label: 'Is Adi', type: 'text' },
            { key: 'aciklama', label: 'Aciklama', type: 'text' },
            { key: 'yil', label: 'Yil', type: 'multi', options: [...new Set(records.map(r => r.yil?.toString()))].filter(Boolean).sort((a,b) => b-a).map(y => ({v:y,l:y})) },
            { key: 'tesis_turu', label: 'Tesis Türü', type: 'multi', options: tesisTuruOptionsFrom(records) },
            { key: 'ilce', label: 'Ilce', type: 'multi', options: [...new Set(records.map(r => r.ilce).filter(Boolean))].sort().map(i => ({v:i,l:i})) },
            { key: 'talep_yeri', label: 'Talep Yeri', type: 'multi', options: [...new Set(records.map(r => r.talep_yeri).filter(Boolean))].sort().map(t => ({v:t,l:t})) },
            { key: 'ilgilenen_memur', label: 'Ilgilenen Memur', type: 'multi', options: [...new Set(records.map(r => r.ilgilenen_memur).filter(Boolean))].sort().map(m => ({v:m,l:m})) },
            { key: 'odenek_durumu', label: 'Ödenek Durumu', type: 'multi', options: [...new Set(records.map(r => r.odenek_durumu).filter(Boolean))].sort().map(d => ({v:d,l:d})) },
            { key: 'alim_turu', label: 'Alim Türü', type: 'multi', options: [...new Set(records.map(r => r.alim_turu).filter(Boolean))].sort().map(a => ({v:a,l:a})) },
            { key: 'butce_tertibi', label: 'Bütce Tertibi', type: 'multi', options: [...new Set(records.map(r => r.butce_tertibi).filter(Boolean))].sort().map(b => ({v:b,l:b})) },
          ]}
        />

        {/* Records Table */}
        <Card className="bg-gray-900 border-gray-800">
          <CardHeader>
            <CardTitle className="text-white">Ödenek Talepleri ({filteredRecords.length} / {records.length})</CardTitle>
          </CardHeader>
          <CardContent>
            {filteredRecords.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-400">
                  {records.length === 0 ? 'Henüz ödenek talebi eklenmemiş' : 'Filtreye uygun kayıt bulunamadı'}
                </p>
              </div>
            ) : (
              <>
              <div className="flex justify-end mb-2 px-2">
                <SortSelect value={sortKey} onChange={setSortKey} options={['newest','oldest','updated','name_asc','name_desc','amount_high','amount_low']} />
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left text-gray-300">
                  <thead className="text-xs text-gray-400 uppercase bg-gray-800">
                    <tr>
                      <th className="px-4 py-3">
                        <Checkbox
                          checked={selectedRows.length === filteredRecords.length && filteredRecords.length > 0}
                          onCheckedChange={toggleAllRows}
                          className="border-gray-600"
                        />
                      </th>
                      <th className="px-4 py-3">S.NO</th>
                      <th className="px-4 py-3">Yıl</th>
                      <th className="px-4 py-3">İşin Adı</th>
                      <th className="px-4 py-3">Tesis Türü</th>
                      <th className="px-4 py-3">İlçe</th>
                      <th className="px-4 py-3">İlgilenen Memur</th>
                      <th className="px-4 py-3">Ödenek Tutarı</th>
                      <th className="px-4 py-3">Durum</th>
                      {user?.is_admin && <th className="px-4 py-3">Son Düzenleyen</th>}
                      <th className="px-4 py-3">İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortData(filteredRecords, sortKey, 'isin_adi', 'odenek_tutari').map((record, index) => (
                      <tr key={record.id} className="border-b border-gray-800 hover:bg-gray-800/50 cursor-pointer" data-testid={`bakim-row-${record.id}`}
                        onClick={(e) => { if (e.target.closest('button, input, a, [role="checkbox"]')) return; setDetailRecord(record); }}>
                        <td className="px-4 py-3">
                          <Checkbox
                            checked={selectedRows.includes(record.id)}
                            onCheckedChange={() => toggleRowSelection(record.id)}
                            className="border-gray-600"
                          />
                        </td>
                        <td className="px-4 py-3">{index + 1}</td>
                        <td className="px-4 py-3">{record.yil || '-'}</td>
                        <td className="px-4 py-3 max-w-md truncate" title={record.isin_adi}>{record.isin_adi || '-'}</td>
                        <td className="px-4 py-3">{tesisTuruText(record.tesis_turu) || '-'}</td>
                        <td className="px-4 py-3">{record.ilce || '-'}</td>
                        <td className="px-4 py-3">{record.ilgilenen_memur || '-'}</td>
                        <td className="px-4 py-3">{displayMoney(record.odenek_tutari)}</td>
                        <td className="px-4 py-3">{record.odenek_durumu || '-'}</td>
                        {user?.is_admin && (
                          <td className="px-4 py-3 text-xs text-gray-400">
                            {record.last_modified_by_name || '-'}
                            {record.last_modified_at && <div className="text-gray-500 mt-0.5">{new Date(record.last_modified_at).toLocaleString('tr-TR')}</div>}
                          </td>
                        )}
                        <td className="px-4 py-3">
                          <div className="flex gap-2">
                            {!user?.is_viewer && (
                              <>
                                <Button
                                  onClick={() => handleEdit(record)}
                                  size="sm"
                                  variant="ghost"
                                  className="text-blue-400 hover:text-blue-300"
                                >
                                  Düzenle
                                </Button>
                                {user?.is_admin && (
                                  <Button
                                    onClick={() => handleDelete(record.id)}
                                    size="sm"
                                    variant="ghost"
                                    className="text-red-400 hover:text-red-300"
                                  >
                                    Sil
                                  </Button>
                                )}
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              </>
            )}
          </CardContent>
        </Card>

        {/* Finansal Özet - Seçili Kayıtlar */}
        {selectedRows.length > 0 && (
          <Card className="bg-gradient-to-br from-blue-900/20 to-purple-900/20 border-blue-700/50 mt-6">
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle className="text-blue-400">📊 Finansal Özet - Seçili Kayıtlar</CardTitle>
                <Button
                  onClick={exportSelectedToPDF}
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Seçilenleri PDF İndir
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-gray-800/50 rounded-lg p-4">
                  <p className="text-xs text-gray-400 mb-1">Seçili Kayıt Sayısı</p>
                  <p className="text-3xl font-bold text-white">{getSelectedRecordsSummary().count}</p>
                </div>
                <div className="bg-gray-800/50 rounded-lg p-4">
                  <p className="text-xs text-gray-400 mb-1">Toplam Ödenek Tutarı</p>
                  <p className="text-3xl font-bold text-green-400">{displayMoney(getSelectedRecordsSummary().totalOdenek)}</p>
                </div>
                <div className="bg-gray-800/50 rounded-lg p-4">
                  <p className="text-xs text-gray-400 mb-1">Ortalama Tutar</p>
                  <p className="text-3xl font-bold text-purple-400">
                    {displayMoney((parseFloat(getSelectedRecordsSummary().totalOdenek.replace(',', '.')) / getSelectedRecordsSummary().count).toFixed(2).replace('.', ','))}
                  </p>
                </div>
              </div>

              {/* Detaylı Liste */}
              <div className="mt-6">
                <h4 className="text-sm font-medium text-gray-300 mb-3">Seçili Kayıtlar Detayı:</h4>
                <div className="space-y-2">
                  {getSelectedRecordsSummary().records.map((record, idx) => (
                    <div key={record.id} className="bg-gray-800/30 rounded p-3 flex items-center justify-between">
                      <div className="flex-1">
                        <p className="text-sm text-white font-medium">{idx + 1}. {record.isin_adi}</p>
                        <p className="text-xs text-gray-400 mt-1">
                          {tesisTuruText(record.tesis_turu) || '-'} • {record.yil} • {record.ilce || 'İlçe yok'}
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="text-lg font-bold text-green-400">{displayMoney(record.odenek_tutari)}</p>
                        <p className="text-xs text-gray-400">{record.odenek_durumu}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </CardContent>
          </Card>
        )}
      </main>

      {/* Add/Edit Dialog */}
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent className="bg-gray-900 border-gray-800 text-white max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{editMode ? 'Talebi Düzenle' : 'Yeni Talep Ekle'}</DialogTitle>
            <DialogDescription className="text-gray-400">
              Talep bilgilerini girin
            </DialogDescription>
          </DialogHeader>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4">
            <div className="space-y-2">
              <Label>YIL *</Label>
              <Input
                value={formData.yil}
                onChange={(e) => setFormData({ ...formData, yil: e.target.value })}
                className="bg-gray-800 border-gray-700 text-white"
                placeholder="2024"
                required
              />
            </div>

            <div className="space-y-2">
              <Label>TESİS TÜRÜ * (çoklu seçim)</Label>
              <TesisTuruSecici value={formData.tesis_turu} onChange={(codes) => setFormData({ ...formData, tesis_turu: codes })} testId="bakim-tesis-turu-secici" />
            </div>

            <div className="space-y-2 md:col-span-2">
              <Label>İŞİN ADI *</Label>
              <Textarea
                value={formData.isin_adi}
                onChange={(e) => setFormData({ ...formData, isin_adi: e.target.value })}
                className="bg-gray-800 border-gray-700 text-white"
                rows={3}
                placeholder="Örn: Maltepe Gençlik Merkezi mekanik bakım onarım işleri"
                required
              />
            </div>

            <div className="space-y-2">
              <Label>İLÇE (İstanbul)</Label>
              <Select value={formData.ilce} onValueChange={(value) => setFormData({ ...formData, ilce: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white">
                  <SelectValue placeholder="İlçe seçin" />
                </SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white max-h-60">
                  {ISTANBUL_ILCELERI.map((ilce) => (
                    <SelectItem key={ilce} value={ilce}>{ilce}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label>ALIM TÜRÜ</Label>
              <Select value={formData.alim_turu} onValueChange={(value) => setFormData({ ...formData, alim_turu: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white">
                  <SelectValue placeholder="Seçiniz" />
                </SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white">
                  <SelectItem value="22/a">22/a</SelectItem>
                  <SelectItem value="22/c">22/c</SelectItem>
                  <SelectItem value="22/d">22/d</SelectItem>
                  <SelectItem value="dogrudan_temin">Doğrudan Temin</SelectItem>
                  <SelectItem value="acik_ihale">Açık İhale</SelectItem>
                  <SelectItem value="pazarlik">Pazarlık</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label>TALEP YERİ *</Label>
              <Select value={formData.talep_yeri} onValueChange={(value) => setFormData({ ...formData, talep_yeri: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white">
                  <SelectValue placeholder="Seçiniz" />
                </SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white">
                  <SelectItem value="STRATEJİ">STRATEJİ</SelectItem>
                  <SelectItem value="YİGM">YİGM</SelectItem>
                  <SelectItem value="GENÇLİK HİZMETLERİ GEN. MD.">GENÇLİK HİZMETLERİ GEN. MD.</SelectItem>
                  <SelectItem value="SPOR GEN MD.">SPOR GEN MD.</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label>BÜTÇE TERTİBİ</Label>
              <Select value={formData.butce_tertibi} onValueChange={(value) => setFormData({ ...formData, butce_tertibi: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white">
                  <SelectValue placeholder="Seçiniz" />
                </SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white max-h-60">
                  {BUTCE_TERTIBI_KODLARI.map((kod) => (
                    <SelectItem key={kod} value={kod}>{kod}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label>ÖDENEK TUTARI (KDV DAHİL)</Label>
              <Input
                value={formData.odenek_tutari}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9,]/g, '');
                  setFormData({ ...formData, odenek_tutari: value });
                }}
                className="bg-gray-800 border-gray-700 text-white"
                placeholder="Örn: 28084,50"
              />
              {formData.odenek_tutari && (
                <p className="text-xs text-gray-400 mt-1">
                  Görünüm: {displayMoney(formData.odenek_tutari)}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <Label>İLGİLENEN MEMUR</Label>
              <Select value={formData.ilgilenen_memur} onValueChange={(value) => setFormData({ ...formData, ilgilenen_memur: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white">
                  <SelectValue placeholder="Seçiniz" />
                </SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white">
                  {users.map((u) => (
                    <SelectItem key={u.id} value={u.name}>{u.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label>ÖDENEK TALEP TARİHİ</Label>
              <Input
                type="date"
                value={formData.odenek_talep_tarihi}
                onChange={(e) => setFormData({ ...formData, odenek_talep_tarihi: e.target.value })}
                className="bg-gray-800 border-gray-700 text-white"
              />
            </div>

            <div className="space-y-2">
              <Label>TALEP YAZI NO</Label>
              <Input
                value={formData.talep_yazi_no}
                onChange={(e) => setFormData({ ...formData, talep_yazi_no: e.target.value })}
                className="bg-gray-800 border-gray-700 text-white"
                placeholder="Örn: 2023-4692844"
              />
            </div>

            <div className="space-y-2">
              <Label>ÖDENEK DURUMU *</Label>
              <Select value={formData.odenek_durumu} onValueChange={(value) => setFormData({ ...formData, odenek_durumu: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white">
                  <SelectValue placeholder="Seçiniz" />
                </SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white">
                  <SelectItem value="GELDİ">GELDİ</SelectItem>
                  <SelectItem value="GELDİ-ÖDENDİ">GELDİ-ÖDENDİ</SelectItem>
                  <SelectItem value="GELMEDİ">GELMEDİ</SelectItem>
                  <SelectItem value="İPTAL EDİLDİ">İPTAL EDİLDİ</SelectItem>
                  <SelectItem value="EMANETE ALINDI">EMANETE ALINDI</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2 md:col-span-2">
              <Label>AÇIKLAMA</Label>
              <Textarea
                value={formData.aciklama}
                onChange={(e) => setFormData({ ...formData, aciklama: e.target.value })}
                className="bg-gray-800 border-gray-700 text-white"
                rows={3}
                placeholder="İlave açıklamalar..."
              />
            </div>
          </div>

          <DialogFooter>
            <Button
              onClick={() => {
                setDialogOpen(false);
                resetForm();
              }}
              variant="ghost"
              className="text-gray-400"
            >
              İptal
            </Button>
            <Button onClick={handleSubmit} disabled={submitting} className="bg-blue-600 hover:bg-blue-700 text-white">
              {submitting ? 'Kaydediliyor...' : (editMode ? 'Güncelle' : 'Ekle')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Satıra tıklanınca açılan bilgi kartı */}
      <OdenekDetailDialog
        open={!!detailRecord}
        onOpenChange={(v) => { if (!v) setDetailRecord(null); }}
        record={detailRecord}
        displayMoney={displayMoney}
        dtLinked={!!detailRecord && dtLinkedIds.has(detailRecord.id)}
        canEdit={!user?.is_viewer}
        onEdit={(rec) => handleEdit(rec)}
        onExportPDF={(rec) => exportOdenekDetayPDF(rec, { displayMoney, dtLinked: dtLinkedIds.has(rec.id) })}
        onOpenDT={() => navigate('/bakim-onarim/dogrudan-temin')}
      />

      {/* PDF Sütun Seçimi Dialog */}
      <ExportDialog
        open={pdfDialogOpen}
        onOpenChange={setPdfDialogOpen}
        columns={BAKIM_EXPORT_COLUMNS}
        selectedColumns={selectedColumns}
        onToggleColumn={toggleColumn}
        onSelectAll={() => selectAll(BAKIM_EXPORT_COLUMNS)}
        onClearAll={clearAll}
        pdfPageSize={pdfPageSize}
        onPdfPageSizeChange={setPdfPageSize}
        onExportPDF={exportToPDF}
        title="PDF İçin Sütun Seçin"
        description="PDF raporunda görmek istediğiniz sütunları seçin"
        quickSelect={{
          label: 'Hızlı Seçim (5 Temel)',
          onSelect: () => setSelectedColumns(['yil', 'isin_adi', 'ilce', 'odenek_tutari', 'odenek_durumu'])
        }}
        idPrefix="bakim-pdf"
      />

      <ExportDialog
        open={excelDialogOpen}
        onOpenChange={setExcelDialogOpen}
        columns={BAKIM_EXPORT_COLUMNS}
        selectedColumns={selectedColumns}
        onToggleColumn={toggleColumn}
        onSelectAll={() => selectAll(BAKIM_EXPORT_COLUMNS)}
        onClearAll={clearAll}
        onExportExcel={exportToExcel}
        title="Excel İçin Sütun Seçin"
        description="Excel raporunda görmek istediğiniz sütunları seçin"
        quickSelect={{
          label: 'Hızlı Seçim (5 Temel)',
          onSelect: () => setSelectedColumns(['yil', 'isin_adi', 'ilce', 'odenek_tutari', 'odenek_durumu'])
        }}
        idPrefix="bakim-excel"
      />

      <ExportDialog
        open={selectedPdfDialogOpen}
        onOpenChange={setSelectedPdfDialogOpen}
        columns={BAKIM_EXPORT_COLUMNS}
        selectedColumns={selectedColumns}
        onToggleColumn={toggleColumn}
        onSelectAll={() => selectAll(BAKIM_EXPORT_COLUMNS)}
        onClearAll={clearAll}
        pdfPageSize={pdfPageSize}
        onPdfPageSizeChange={setPdfPageSize}
        onExportPDF={exportSelectedToPDFWithColumns}
        title="Seçili Kayıtlar PDF - Sütun Seçin"
        description={`Seçili ${getSelectedRecordsSummary().count} kayıt için PDF raporunda görmek istediğiniz sütunları seçin`}
        quickSelect={{
          label: 'Hızlı Seçim (5 Temel)',
          onSelect: () => setSelectedColumns(['yil', 'isin_adi', 'ilce', 'odenek_tutari', 'odenek_durumu'])
        }}
        idPrefix="bakim-selected-pdf"
      />

    </div>
  );
};

export default BakimOnarimPage;
